module.exports = __webpack_public_path__ + "img/tailwind-icon.de976cd0.svg";